/**
 * Returns true if the entry represents any active bleeding (spotting, light, medium, heavy).
 * Supports both new flowLevel-based entries and legacy bleeding-boolean entries.
 */
export function isActiveBleeding(entry) {
    if (entry.flowLevel)
        return entry.flowLevel !== 'none';
    return entry.bleeding === true;
}
/**
 * Returns true if the entry represents menstrual-period bleeding (light, medium, heavy — NOT spotting).
 * Use this for period detection in cycle prediction. Spotting on contraception
 * should not count as a period start or inflate period length.
 */
export function isPeriodBleeding(entry) {
    if (entry.flowLevel)
        return ['light', 'medium', 'heavy'].includes(entry.flowLevel);
    // Legacy entries without flowLevel: fall back to bleeding boolean
    return entry.bleeding === true;
}
/**
 * Returns true if the entry is explicitly spotting-only (not period bleeding).
 */
export function isSpottingOnly(entry) {
    return entry.flowLevel === 'spotting';
}
